<form [formGroup]="form">
    <div class="heading-wrapper">
        <h2>Export data to csv</h2>
        <p *ngIf="exportConfig.exportOptions.length > 1">Please select the data export type from the options below.</p>
    </div>

    <ng-container *ngIf="exportConfig.exportOptions.length > 1">
        <div ngbDropdown #myDropdown="ngbDropdown" class="container">
            <button class="btn btn-outline-primary mr-1" id="dropdownBasic1" ngbDropdownToggle>
                {{ selectedOption.name }}
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <ng-container *ngFor="let exportOption of exportConfig.exportOptions">
                    <button class="dropdown-item" (click)="selectedExport(exportOption)">{{ exportOption.name }}</button>
                </ng-container>
            </div>
        </div>
    </ng-container>
    <div class="container">
        <div [class.checkbox-container]="exportConfig.exportOptions.length > 1">
            <p *ngIf="selectedOption.description">{{selectedOption.description}}</p>
            <p>Select the fields to be included</p>
            <ng-container *ngFor="let formControl of form.controls | keyvalue">
                <div class="custom-control custom-checkbox">
                    <input
                        type="checkbox"
                        class="custom-control-input"
                        name="{{ formControl.key }}"
                        id="{{ formControl.key }}"
                        formControlName="{{ formControl.key }}"
                    />
                    <label class="custom-control-label" for="{{ formControl.key }}"
                        ><span>{{ formControl.key }}</span></label
                    >
                </div>
            </ng-container>
        </div>
    </div>

    <div class="button-wrapper">
        <button type="button" class="btn btn-sm btn-outline-dark mr-2" (click)="onSubmit()" [disabled]="loading$ | async">
            <span *ngIf="!(loading$ | async); else loadingSpinner">Download</span>
        </button>
        <button type="button" class="btn btn-sm btn-outline-dark mr-2" >
            <i class="ft-mail"></i>
            <span>Email All Users</span>
        </button>
        <button type="button" class="btn btn-sm btn-outline-dark mr-2" (click)="closeModal()">Close</button>
    </div>
</form>

<ng-template #loadingSpinner>
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    Downloading...
</ng-template>
